var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 11.75L9.375 5.2625L20.625 11.75ZM26.25 20V10C26.2496 9.56159 26.1338 9.13101 25.9144 8.75145C25.695 8.37189 25.3797 8.0567 25 7.8375L16.25 2.8375C15.87 2.61808 15.4388 2.50256 15 2.50256C14.5612 2.50256 14.13 2.61808 13.75 2.8375L5 7.8375C4.62033 8.0567 4.30498 8.37189 4.08558 8.75145C3.86618 9.13101 3.75045 9.56159 3.75 10V20C3.75045 20.4384 3.86618 20.869 4.08558 21.2485C4.30498 21.6281 4.62033 21.9433 5 22.1625L13.75 27.1625C14.13 27.3819 14.5612 27.4974 15 27.4974C15.4388 27.4974 15.87 27.3819 16.25 27.1625L25 22.1625C25.3797 21.9433 25.695 21.6281 25.9144 21.2485C26.1338 20.869 26.2496 20.4384 26.25 20Z",
    stroke: "#959595",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0008 15L4.11328 8.75L15.0008 2.5L25.8883 8.75L15.0008 15ZM15.0008 15V27.5",
    stroke: "#959595",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderInactive);
export default __webpack_public_path__ + "static/media/order_inactive.990486b42e6bddaf7ab381554559beaf.svg";
export { ForwardRef as ReactComponent };